import React from 'react';
import Button from '../../../../component/ui/Button';
function TableHeaderComponent({
	bulkAction,
	buttons,
	closeButton,
	dropdownButton,
	createButton,
	moreButton,
	advanceFilterButton,
	usageIndicator,
}) {
	return bulkAction && bulkAction.length > 0 ? (
		<div
			className="product-pg-header"
			style={{ padding: '1.6rem 1rem' }}
		>
			<div className="dropdown text-end">
				<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
			</div>
			<div className="add-product-button">
				{buttons
					.filter((button) => button !== false)
					?.map((button, index) => (
						<Button
							key={button?.id || index}
							type="button"
							button={button?.button}
							className={`${button?.className} mt-0 px-4`}
							onClick={button?.handler}
							disabled={button.disabled || false}
						/>
					))}
				{closeButton?.showCloseButton && (
					<Button
						type="button"
						close
						button=""
						className="mt-0 btn-danger add-pro"
						onClick={closeButton?.handler}
					/>
				)}
			</div>
		</div>
	) : (
		<div className="product-pg-header add-product">
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 12,
				}}
			>
				<div className="dropdown text-end">{dropdownButton}</div>
				<div>{advanceFilterButton}</div>
			</div>
			<div className="add-product-button column-gap-0 d-flex align-items-center gap-3">
				{usageIndicator}
				{createButton && (
					<Button
						type="button"
						button={createButton.buttonName}
						disabled={createButton.disabled || false}
						className="btn-primary mt-0 px-5"
						add
						onClick={createButton?.handler}
					/>
				)}
				{moreButton}
			</div>
		</div>
	);
}
export default TableHeaderComponent;
